import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689db969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mortgage-block__cards mb--10" }
const _hoisted_3 = { class: "medium textHidden" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "mortgage-block__card-info"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " от ", -1))
const _hoisted_7 = { class: "blue-color" }
const _hoisted_8 = { class: "mortgage-block__widget" }

import { computed } from 'vue';
import { RateType } from '@/types/MainPageTypes';
import { MortgageWidget } from '@/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'MortgageBlock',
  props: {
    mortgage: {},
    showRates: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;
const mortgageData = computed((): RateType[] => {
  if (props.mortgage) {
    return props.mortgage;
  }

  return [];
});

return (_ctx: any,_cache: any) => {
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showRates)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mortgageData.value, (mortgage, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "align-left"
              }, [
                _createVNode(_component_base_card, { class: "mortgage-block__card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(mortgage.title), 1),
                    (mortgage.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "-"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(mortgage.minRate || '-') + "%", 1),
                          _createVNode(_component_base_divider, {
                            color: "#000",
                            inset: "80%",
                            vertical: ""
                          }),
                          _createElementVNode("span", null, _toDisplayString(mortgage.minPayment ? mortgage.minPayment?.toLocaleString() : '-') + " ₽", 1)
                        ]))
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(MortgageWidget))
    ])
  ], 64))
}
}

})